import axios from "axios";
import { BASE_URL } from "../../constant/staticUrl";

const API = axios.create({ baseURL: BASE_URL });

API.interceptors.request.use((req) => {
  try {
    const secretToken = localStorage.getItem("token");
    if (secretToken) {
      req.headers.Authorization = `Token ${secretToken}`;
    }
    return req;
  } catch (err) {
    console.error("Request Interceptor Error:", err);
  }
});

const config = {
  headers: {
    "Content-Type": "application/json",
  },
};

export const mentorLoginApi = async (formData) => {
  try {
    const { data } = await API.post(`/mentor/login`, formData, config);

    if (data.token) {
      localStorage.setItem("token", data.token);
    }
    if(data.mentorName) {
      localStorage.setItem("mentorName", data.mentorName);
    }

    return data;
  } catch (error) {
    console.error("Login API Error:", error);
    throw error;
  }
};
